import type {TimeRemaining, UseCountdownToDateOptions, UseCountdownToDateResult} from '../types';

import {useEffect, useRef, useState} from 'react';

import {calculateTimeRemaining} from '../utils/formatDuration';

export function useCountdownToDate({
  targetDate,
  onExpire,
  expiredLabel
}: UseCountdownToDateOptions): UseCountdownToDateResult {
  const [timeRemaining, setTimeRemaining] = useState<TimeRemaining | string>(() =>
    targetDate ? calculateTimeRemaining(targetDate, expiredLabel) : (expiredLabel ?? 'پایان زمان')
  );
  const onExpireRef = useRef(onExpire);

  useEffect(() => {
    onExpireRef.current = onExpire;
  }, [onExpire]);

  useEffect(() => {
    if (!targetDate) {
      setTimeRemaining(expiredLabel ?? 'پایان زمان');
      return;
    }

    const update = () => {
      const next = calculateTimeRemaining(targetDate, expiredLabel);
      setTimeRemaining(next);
      if (typeof next === 'string') {
        onExpireRef.current?.();
      }
    };

    update();
    const intervalId = window.setInterval(update, 1000);
    return () => window.clearInterval(intervalId);
  }, [targetDate, expiredLabel]);

  const isExpired = typeof timeRemaining === 'string';

  return {timeRemaining, isExpired};
}
